export const previewswitchConstants = {
    YES : 'WITH_IMAGES',
    NO : 'ONLY_WITH_HEADLINES'
};